module.exports = __webpack_public_path__ + "static/media/9MOBILE.dfa845eb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/discos/9MOBILE.svg
// module id = 382
// module chunks = 25